import React, { useEffect, useState } from 'react';
import './FollowedUsers.scss';
import { http, general, localstorage, useNavigationService, AlertService } from '../../fx-core';

import {
  Button,
  Drawer,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Link,
  Typography,
  Breadcrumbs,
  CircularProgress,
  Box,
  Card,
  CardContent,
  CardActions,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Tabs,
  Tab,
  Checkbox,
  Tooltip
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SettingsIcon from '@material-ui/icons/Settings';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import GroupIcon from '@material-ui/icons/Group';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';
import SendIcon from '@material-ui/icons/Send';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import MessageContainer from '../../MessageContainer/MessageContainer';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CreateTrueFansGroupModal from '../CreateServiceRequestContainer/CreateTrueFansGroupModal/CreateTrueFansGroupModal';
import dummyImage from '../../../assets/images/dummy.png';

enum MessageEntityType {
  User = 5
}

const useStyles = makeStyles((theme) => (({
  drawerWidth: {
    [theme.breakpoints.down(599)]: { width: '90%' },
    [theme.breakpoints.up(600)]: { width: '70%' },
    [theme.breakpoints.up(1025)]: { width: '40%' }
  },
  topRightButton: {
    position: 'absolute',
    top: 20,
    right: 20,
    zIndex: 10
  },
  groupsContainer: {
    margin: theme.spacing(2, 1),
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap'
  },
  groupCard: {
    minWidth: 240,
    maxWidth: 320,
    flex: '0 0 auto',
    borderRadius: 8,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-3px)',
      boxShadow: '0 6px 16px rgba(0,0,0,0.15)'
    }
  },
  notificationDialog: {
    '& .MuiDialog-paper': {
      minWidth: '800px',
      maxWidth: '900px',
      width: '95%',
      borderRadius: '12px',
      maxHeight: '85vh',
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('md')]: {
        minWidth: '95%',
        maxWidth: '95%'
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: '90%',
        maxWidth: '90%',
        maxHeight: '90vh'
      }
    }
  },
  confirmDialog: {
    '& .MuiDialog-paper': {
      borderRadius: '12px',
      minWidth: '400px'
    }
  },
  tabsContainer: {
    borderBottom: '1px solid #e0e0e0',
    backgroundColor: '#fff'
  },
  tabButton: {
    minWidth: 120,
    fontWeight: 600,
    '&.Mui-selected': {
      color: '#f69516',
      fontWeight: 700
    }
  },
  tabIndicator: {
    backgroundColor: '#f69516',
    height: 3
  },
  memberRow: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5),
    borderBottom: '1px solid #e0e0e0',
    backgroundColor: '#fafafa',
    marginBottom: '4px',
    borderRadius: '4px',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    },
    '&.selected': {
      backgroundColor: '#e3f2fd',
      borderLeft: '3px solid #2196f3'
    }
  },
  deleteButton: {
    color: '#d32f2f !important',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#ffebee',
      transform: 'scale(1.1)'
    }
  },
  bulkDeleteButton: {
    backgroundColor: '#d32f2f !important',
    color: '#fff !important',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#b71c1c !important'
    },
    '&:disabled': {
      backgroundColor: '#ccc !important',
      color: '#999 !important'
    }
  },
  sendButtonEnabled: {
    backgroundColor: '#8ec73d !important',
    color: '#fff !important',
    fontWeight: 700,
    '&:hover': {
      backgroundColor: '#7ab82c !important'
    }
  },
  sendButtonDisabled: {
    backgroundColor: '#ccc !important',
    color: '#999 !important',
    fontWeight: 700
  },

  waTemplateButton: {
    minWidth: 140,
    borderRadius: 8,
    textTransform: 'none',
    padding: '8px 12px',
    fontWeight: 600,
    boxShadow: 'none',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 6px 14px rgba(0,0,0,0.06)'
    }
  },
  waTemplateActive: {
    backgroundColor: '#f69516 !important',
    color: '#fff !important',
    '&:hover': {
      backgroundColor: '#ec8e15 !important'
    }
  },
  waPreviewImg: {
    width: 300,
    height: 'auto',
    borderRadius: 6,
    display: 'block'
  },

  dialogContent: {
    padding: '24px',
    flex: 1,
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '6px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
      borderRadius: '4px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#ccc',
      borderRadius: '4px',
      '&:hover': {
        backgroundColor: '#999'
      }
    }
  }
})));

type Follower = {
  id: number;
  firstName?: string;
  lastName?: string;
  profileImagePath?: string;
  profileImageUrl?: string;
};

type GroupData = {
  id: number;
  groupName: string;
  description?: string;
  memberCount: number;
  createdDate?: string;
  // For individual-target usage:
  userId?: number;
  isIndividual?: boolean;
};

type MemberData = {
  userId: number;
  firstName: string;
  lastName?: string;
  profileImagePath?: string;
};

type ConfirmDialogState = {
  open: boolean;
  title: string;
  message: string;
  onConfirm: (() => void) | null;
  isLoading: boolean;
};

// dd/mm/yyyy validation - small util
const isValidDateFormat = (value: string): boolean => {
  const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
  if (!regex.test(value)) return false;

  const [day, month, year] = value.split('/').map(Number);
  const date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};

const FollowedUsers: React.FC<any> = (props) => {
  const classes = useStyles();
  const { navigate } = useNavigationService();

  // ================== STATE: Basic Setup ==================
  const routeStallId = props?.match?.params?.id ? parseInt(props.match.params.id) : 0;
  const [currentContext, setCurrentContext] = useState<{ stallName: string }>({ stallName: '' });
  const [stallId, setStallId] = useState<number>(routeStallId || 0);
  const [userList, setUserList] = useState<Follower[]>([]);
  const [userId] = useState<number>(() => parseInt(localstorage.getItem("userId") || '0'));

  // ================== HELPER: Get Existing ThreadId ==================
const getExistingThreadId = async (recipientId: number): Promise<string | null> => {
  try {
    const inputData = {
      threadId: null,
      userId: userId
    };

    // Query all messages for current user
    const apiOptions: any = {
      url: `message/query/user/${userId}`,
      data: null
    };
    const res = await http.get(apiOptions);
    const allUserMessages = res?.data || [];

    // Find messages with this specific recipient (msgEntityTypeId = 5 for User)
    const existingThread = allUserMessages.find(
      msg =>
        msg.msgEntityTypeId === MessageEntityType.User &&
        (msg.targetUserId === recipientId || msg.entityId === recipientId)
    );

    if (existingThread && existingThread.threadId) {
      console.log(`Found existing threadId for user ${recipientId}: ${existingThread.threadId}`);
      return existingThread.threadId;
    }

    console.log(`No existing thread found for user ${recipientId}, backend will create new one`);
    return null;
  } catch (err) {
    console.warn(`Error getting existing thread for user ${recipientId}:`, err);
    return null;
  }
};

  
  // ================== STATE: Stall Link Generation (MODIFIED) ==================
  const [stallSlug, setStallSlug] = useState<string>('');
  const [generatedMobileLink, setGeneratedMobileLink] = useState<string>('');
  const [loadingMobileLink, setLoadingMobileLink] = useState<boolean>(false);
  const generatedStallLink = generatedMobileLink;

  // ================== STATE: Message Container (DM) ==================
  const [openMessage, setOpenMessage] = useState(false);
  const [followedUserId, setFollowedUserId] = useState(0);

  // ================== STATE: Groups ==================
  const [groups, setGroups] = useState<GroupData[]>([]);
  const [loadingFollowers, setLoadingFollowers] = useState(false);
  const [loadingGroups, setLoadingGroups] = useState(false);

  // ================== STATE: Confirmation Dialog ==================
  const [confirmDialog, setConfirmDialog] = useState<ConfirmDialogState>({
    open: false,
    title: '',
    message: '',
    onConfirm: null,
    isLoading: false
  });

  // ================== STATE: Members Dialog (Edit/View) ==================
  const [openMembersDialog, setOpenMembersDialog] = useState(false);
  const [membersDialogData, setMembersDialogData] = useState<any>(null);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [selectedUsersToAdd, setSelectedUsersToAdd] = useState<Follower[]>([]);
  const [selectedUsersToRemove, setSelectedUsersToRemove] = useState<number[]>([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [removingMultiple, setRemovingMultiple] = useState(false);

  // ================== STATE: Create TrueFans Group Modal ==================
  const [openCreateTrueFansGroup, setOpenCreateTrueFansGroup] = useState(false);

  // ================== STATE: Group Messaging Dialog & Tabs ==================
  const [openNotificationDialog, setOpenNotificationDialog] = useState(false);
  const [selectedGroupForNotification, setSelectedGroupForNotification] = useState<GroupData | null>(null);
  const [selectedTab, setSelectedTab] = useState(0);

  // ================== STATE: DM Tab (Individual DMs to Group Members) ==================
  const [dmMessage, setDmMessage] = useState('');
  const [dmSending, setDmSending] = useState(false);

  // ================== STATE: Push Notification Tab ==================
  const [pushTitle, setPushTitle] = useState('');
  const [pushBody, setPushBody] = useState('');
  const [pushImageUrl, setPushImageUrl] = useState('');
  const [pushLink, setPushLink] = useState('');
  const [pushSending, setPushSending] = useState(false);

  // ================== STATE: WhatsApp ==================
  const [waSending, setWaSending] = useState(false);
  const [waTemplate, setWaTemplate] = useState<'new_product' | 'discount'>('new_product');
  // hold inline preview image URL
  const [waPreviewImage, setWaPreviewImage] = useState<string>('');

  // Template 1
  const [waProductName, setWaProductName] = useState('');
  const [waDate, setWaDate] = useState('');
  const [waProductLink, setWaProductLink] = useState('');
  const [waDateError, setWaDateError] = useState(false);

  // Template 2
  const [waDiscountLink, setWaDiscountLink] = useState('');

  // ================== EFFECTS ==================
  useEffect(() => {
    if (stallId) getStallById();
  }, [stallId]);

  useEffect(() => {
    const rId = props?.match?.params?.id ? parseInt(props.match.params.id) : 0;
    if (rId && rId !== stallId) setStallId(rId);
  }, [props?.match?.params?.id]);

  // ================== EFFECT: Generate Mobile Stall Link when slug changes (NEW) ==================
  useEffect(() => {
    if (stallId && stallSlug && userId) {
      generateMobileStallLink();
    }
  }, [stallId, stallSlug, userId]);

  // ================== HELPER: Check if Send Button Should be Enabled ==================
  const isSendButtonEnabled = (): boolean => {
    if (selectedTab === 0) {
      // DM Tab: Only message required
      return dmMessage.trim().length > 0;
    } else if (selectedTab === 1) {
      // Push Notification Tab: Title and Body required
      return pushTitle.trim().length > 0 && pushBody.trim().length > 0;
    }
    return false;
  };

  // WhatsApp template validation
  const isWhatsAppSendEnabled = (): boolean => {
    if (waTemplate === 'new_product') {
      const finalLink = (waProductLink && waProductLink.trim()) ? waProductLink.trim() : generatedStallLink;
      // also ensure date is valid (no error)
      return waProductName.trim().length > 0 && waDate.trim().length > 0 && !waDateError && (finalLink && finalLink.trim().length > 0);
    }
    const finalLink2 = (waDiscountLink && waDiscountLink.trim()) ? waDiscountLink.trim() : generatedStallLink;
    return finalLink2 && finalLink2.trim().length > 0;
  };

  // overall send enabled (used for styling)
  const isOverallSendEnabled = (): boolean => {
    if (selectedTab === 0) return isSendButtonEnabled();
    if (selectedTab === 1) return isSendButtonEnabled();
    if (selectedTab === 2) return isWhatsAppSendEnabled();
    return false;
  };

  // ================== NEW: Open notification dialog for an individual user ==================
  const openNotificationForUser = (user: Follower) => {
    const name = `${user.firstName || ''} ${user.lastName || ''}`.trim() || 'User';
    const groupLike: GroupData = {
      id: 0, // 0 indicates not a real "group"
      groupName: name,
      memberCount: 1,
      userId: user.id,
      isIndividual: true
    };

    setSelectedGroupForNotification(groupLike);
    setSelectedTab(0);
    setDmMessage('');
    setPushTitle('');
    setPushBody('');
    setPushImageUrl('');
    setPushLink(generatedStallLink || '');
    setWaProductLink(generatedStallLink || '');
    setWaDiscountLink(generatedStallLink || '');
    setWaPreviewImage(
      waTemplate === 'discount'
        ? 'https://d3e4oen9k5mseu.cloudfront.net/Meta_Promotion_img/Flash_Sale_Sample.png'
        : 'https://d3e4oen9k5mseu.cloudfront.net/Meta_Promotion_img/New_Product_Alert_sample.png'
    );
    setWaDateError(false);
    setOpenNotificationDialog(true);
  };

  const openPushForUser = (user: Follower) => {
    openNotificationForUser(user);
    setSelectedTab(1);
  };

  const openWhatsAppForUser = (user: Follower) => {
    openNotificationForUser(user);
    setSelectedTab(2);
  };

  // ================== Sending functions (support group OR individual) ==================

  // Send DM (group or user)
  // ================== API: SEND DM TO GROUP MEMBERS ==================
const sendDMToGroup = async () => {
  if (!selectedGroupForNotification?.id) {
    AlertService?.showErrorMsg?.('To send a message to an individual user, click the Direct Message icon next to their name in the True-fans list');
    return;
  }
  if (!dmMessage.trim()) {
    AlertService?.showErrorMsg?.('Message cannot be empty');
    return;
  }

  // Show confirmation dialog before sending
  showConfirmation(
    'Send Direct Messages',
    `Are you sure you want to send this message to all ${selectedGroupForNotification.memberCount} members of "${selectedGroupForNotification.groupName}"?`,
    async () => {
      setDmSending(true);
      try {
        const res = await http.get({ url: `truefansgroup/${selectedGroupForNotification.id}`, data: null });
        const payload = res?.data;
        if (!payload?.success || !payload.data) {
          throw new Error('Failed to fetch group members');
        }

        let userIds = payload.data.UserIds ?? payload.data.userIds ?? [];
        if (typeof userIds === "string") {
          userIds = userIds.split(',').map((id: string) => parseInt(id.trim())).filter((id: number) => !isNaN(id) && id > 0);
        }
        if (!Array.isArray(userIds)) userIds = [];
        userIds = userIds.filter(id => id && id !== userId);

        if (userIds.length === 0) {
          AlertService?.showErrorMsg?.('No members in this group');
          setDmSending(false);
          return;
        }

        let successCount = 0;
        let failedCount = 0;
        const failedUserIds: number[] = [];

        for (const recipientId of userIds) {
          if (!recipientId || recipientId === 0) {
            failedCount++;
            failedUserIds.push(recipientId);
            continue;
          }

          try {
            // ========== GET EXISTING THREADID (if any) ===========
            const existingThreadId = await getExistingThreadId(recipientId);

            // ========== SEND MESSAGE ===========
            const messagePayload = {
              threadId: existingThreadId ?? null,
              msgBody: dmMessage.trim(),
              userId: userId,
              entityId: recipientId,
              msgEntityTypeId: MessageEntityType.User
            };

            console.log(`Sending message to ${recipientId} with threadId: ${existingThreadId || 'null (new thread)'}`, messagePayload);

            const sendRes = await http.post({ url: 'message/send', data: messagePayload });

            if (sendRes?.data?.threadId) {
              console.log(`Message sent successfully to ${recipientId}, threadId: ${sendRes.data.threadId}`);
              successCount++;
            } else {
              console.warn(`No threadId returned for ${recipientId}`);
              failedCount++;
              failedUserIds.push(recipientId);
            }
          } catch (err) {
            console.error(`Error sending message to ${recipientId}:`, err);
            failedCount++;
            failedUserIds.push(recipientId);
          }
        }

        if (successCount > 0) {
          let msg = `Message sent successfully to ${successCount} member${successCount > 1 ? 's' : ''}!`;
          if (failedCount > 0) {
            msg += ` (${failedCount} failed)`;
          }
          AlertService?.showSuccessMsg?.(msg);
          closeNotificationDialog();
        } else {
          AlertService?.showErrorMsg?.('Failed to send messages to all members');
        }
      } catch (err) {
        const errorMsg = err instanceof Error ? err.message : 'Failed to send messages to group';
        console.error('sendDMToGroup error:', err);
        AlertService?.showErrorMsg?.(errorMsg);
      } finally {
        setDmSending(false);
      }
    }
  );
};


  // ================== IMPORTANT: Robust Push send with fallbacks for single-user 400 ==================
  const sendPushNotification = async () => {
    // Accept either a selected group OR an individual user
    if (!selectedGroupForNotification) {
      AlertService?.showErrorMsg?.('Select a recipient first');
      return;
    }

    if (!pushTitle.trim() || !pushBody.trim()) {
      AlertService?.showErrorMsg?.('Title and description are required');
      return;
    }

    // Prepare a human-friendly target text
    const targetText = selectedGroupForNotification.isIndividual
      ? `the user ${selectedGroupForNotification.groupName}`
      : `all ${selectedGroupForNotification.memberCount} members of "${selectedGroupForNotification.groupName}"`;

    showConfirmation(
      'Send Push Notification',
      `Are you sure you want to send this push notification to ${targetText}?`,
      async () => {
        setPushSending(true);

        try {
          const isIndividual = !!(selectedGroupForNotification.isIndividual && selectedGroupForNotification.userId);
          // Candidate field sets to try (order matters)
          const baseCommon = {
            imageUrl: pushImageUrl?.trim() || null,
            link: pushLink?.trim() || null,
            createdBy: userId
          };

          // Build the user/group selector part
          const targetByUserIds = isIndividual ? { userIds: [selectedGroupForNotification.userId] } : { groupId: selectedGroupForNotification.id };
          const targetByUserIdSingle = isIndividual ? { userId: selectedGroupForNotification.userId } : null; // some APIs expect single userId

          // Candidate payloads array - tries different field name combinations commonly used on backends
          const candidates: any[] = [];

          // Common: title/body
          candidates.push({
            ...targetByUserIds,
            title: pushTitle.trim(),
            body: pushBody.trim(),
            ...baseCommon
          });

          // Some backends expect 'description' instead of 'body'
          candidates.push({
            ...targetByUserIds,
            title: pushTitle.trim(),
            description: pushBody.trim(),
            ...baseCommon
          });

          // Some backends expect 'heading' and 'message'
          candidates.push({
            ...targetByUserIds,
            heading: pushTitle.trim(),
            message: pushBody.trim(),
            ...baseCommon
          });

          // Some backends expect single 'userId' for individual sends
          if (targetByUserIdSingle) {
            candidates.push({
              ...targetByUserIdSingle,
              title: pushTitle.trim(),
              body: pushBody.trim(),
              ...baseCommon
            });
            candidates.push({
              ...targetByUserIdSingle,
              heading: pushTitle.trim(),
              message: pushBody.trim(),
              ...baseCommon
            });
          }

          // Additional fallback: include both groupId and userIds (some controllers accept either)
          if (isIndividual) {
            candidates.push({
              groupId: selectedGroupForNotification.id || 0,
              userIds: [selectedGroupForNotification.userId],
              title: pushTitle.trim(),
              body: pushBody.trim(),
              ...baseCommon
            });
          }

          // Try each candidate until one succeeds
          let lastError: any = null;
          let success = false;
          for (let i = 0; i < candidates.length; i++) {
            const payload = candidates[i];
            console.info('[push] attempt', i + 1, payload);
            try {
              const res = await http.post({ url: `truefansgroup/send-notification`, data: payload });
              // Consider success if HTTP OK or backend returns success:true
              if (res && (res.status === 200 || res.data?.success === true || res.data === 'OK' || res.data)) {
                console.info('[push] succeeded on attempt', i + 1, 'response:', res?.data);
                success = true;
                break;
              }
            } catch (err: any) {
              lastError = err;
              const status = err?.response?.status;
              const data = err?.response?.data;
              console.warn('[push] attempt failed', i + 1, { status, data });
              // continue trying other payload shapes
            }
          }

          if (success) {
            AlertService?.showSuccessMsg?.('Notification sent successfully!');
            closeNotificationDialog();
          } else {
            // If none succeeded, extract meaningful message
            let msg = 'Failed to send notification';
            if (lastError) {
              const respData = lastError?.response?.data;
              if (respData && (typeof respData === 'string' || respData?.error || respData?.message)) {
                msg = respData.error || respData.message || respData;
              } else if (lastError.message) {
                msg = lastError.message;
              }
            }
            console.error('All push attempts failed', lastError);
            AlertService?.showErrorMsg?.(msg);
          }
        } catch (err) {
          console.error('sendPushNotification error', err);
          const backendMsg = err?.response?.data?.error || err?.message || 'Failed to send notification';
          AlertService?.showErrorMsg?.(backendMsg);
        } finally {
          setPushSending(false);
        }
      }
    );
  };

  // Send WhatsApp (group or user)
  const sendWhatsAppMessage = async () => {
    if (!selectedGroupForNotification) {
      AlertService?.showErrorMsg?.('No recipient selected');
      return;
    }

    // Build confirmation message based on target kind
    const targetText = selectedGroupForNotification.isIndividual
      ? `the user ${selectedGroupForNotification.groupName}`
      : `all ${selectedGroupForNotification.memberCount} members`;

    showConfirmation(
      'Send WhatsApp Message',
      `Are you sure you want to send this WhatsApp message to ${targetText}?`,
      async () => {
        setWaSending(true);
        try {
          // base for both templates
          if (waTemplate === 'new_product') {
            const finalLink = (waProductLink && waProductLink.trim()) ? waProductLink.trim() : (generatedStallLink || '');
            const payloadCommon: any = {
              templateName: 'new_product_alert',
              languageCode: 'en',
              imageUrl: 'https://d3e4oen9k5mseu.cloudfront.net/Meta_Promotion_img/New+Product+WA+Banner.jpg',
              parameters: [
                waProductName.trim(),
                waDate.trim(),
                finalLink
              ],
              createdBy: userId
            };

            if (selectedGroupForNotification.isIndividual && selectedGroupForNotification.userId) {
              // individual WhatsApp send — include userId
              await http.post({
                url: 'truefanswhatsapp/send-whatsapp',
                data: {
                  userId: selectedGroupForNotification.userId,
                  ...payloadCommon
                }
              });
            } else {
              // group send
              await http.post({
                url: 'truefanswhatsapp/send-whatsapp',
                data: {
                  groupId: selectedGroupForNotification.id,
                  ...payloadCommon
                }
              });
            }
          } else {
            // discount template
            const finalLink = (waDiscountLink && waDiscountLink.trim()) ? waDiscountLink.trim() : (generatedStallLink || '');
            const payloadCommon: any = {
              templateName: 'discount_promotions',
              languageCode: 'en_GB',
              imageUrl: 'https://d3e4oen9k5mseu.cloudfront.net/Meta_Promotion_img/Flash+Sale+WA+Banner.jpg',
              parameters: [ finalLink ],
              createdBy: userId
            };

            if (selectedGroupForNotification.isIndividual && selectedGroupForNotification.userId) {
              await http.post({
                url: 'truefanswhatsapp/send-whatsapp',
                data: {
                  userId: selectedGroupForNotification.userId,
                  ...payloadCommon
                }
              });
            } else {
              await http.post({
                url: 'truefanswhatsapp/send-whatsapp',
                data: {
                  groupId: selectedGroupForNotification.id,
                  ...payloadCommon
                }
              });
            }
          }

          AlertService?.showSuccessMsg?.('WhatsApp message sent successfully!');
          // Reset whatsapp form
          setWaProductName('');
          setWaDate('');
          setWaProductLink('');
          setWaDiscountLink('');
          setWaPreviewImage('');
          closeNotificationDialog();
        } catch (err) {
          console.error('WhatsApp send failed', err);
          AlertService?.showErrorMsg?.('Failed to send WhatsApp message');
        } finally {
          setWaSending(false);
        }
      }
    );
  };

  // ================== HELPER: Get Send Button Label ==================
  const getSendButtonLabel = (): string => {
    if (selectedTab === 0 && dmSending) return 'Sending DMs...';
    if (selectedTab === 1 && pushSending) return 'Sending Notification...';
    if (selectedTab === 2 && waSending) return 'Sending WhatsApp...';
    return 'Send';
  };

  // ================== HELPER: Show Confirmation Dialog ==================
  const showConfirmation = (title: string, message: string, onConfirm: () => void) => {
    setConfirmDialog({
      open: true,
      title,
      message,
      onConfirm,
      isLoading: false
    });
  };

  const handleConfirmYes = async () => {
    if (!confirmDialog.onConfirm) return;

    setConfirmDialog(prev => ({ ...prev, isLoading: true }));
    try {
      await confirmDialog.onConfirm();
    } catch (err) {
      console.error('Confirmation action error:', err);
    } finally {
      setConfirmDialog({
        open: false,
        title: '',
        message: '',
        onConfirm: null,
        isLoading: false
      });
    }
  };

  const handleConfirmNo = () => {
    setConfirmDialog({
      open: false,
      title: '',
      message: '',
      onConfirm: null,
      isLoading: false
    });
  };

  // ================== NAVIGATION ==================
  const toggleDrawerMessage = () => setOpenMessage(prev => !prev);

  const navToDashboard = () => {
    const navData = {
      targetRoute: '/provider/providerdashboard',
      targetTitle: "Provider Dashboard",
      targetData: {},
      sourceState: {},
      eventSource: '',
    };
    navigate(navData);
  };

  // ================== API: Generate Mobile Stall Link (NEW) ==================
  const generateMobileStallLink = async () => {
    if (!stallId || !stallSlug || !userId) {
      console.warn('Cannot generate link: missing stallId, stallSlug, or userId');
      return;
    }

    setLoadingMobileLink(true);
    try {
      const res = await http.post({
        url: 'branch/generate-stall-link',
        data: {
          slug: stallSlug,
          userId: userId,
          stallId: stallId
        }
      });

      const result = res?.data;
      if (result) {
        // Assuming API returns { url: "..." } or { link: "..." } or similar
        // Adjust the field name based on your actual API response
        const linkUrl = result.url || result.link || result.stallLink || result.mobileLink || '';
        setGeneratedMobileLink(linkUrl);
      }
    } catch (err) {
      console.error('Error generating mobile stall link:', err);
      AlertService?.showErrorMsg?.('Failed to generate mobile link');
      setGeneratedMobileLink('');
    } finally {
      setLoadingMobileLink(false);
    }
  };

  // ================== API: GET Stall & Initialize Data ==================
  const getStallById = async () => {
    try {
      const apiOptions: any = { url: `stall/${stallId}`, data: null };
      const res = await http.get(apiOptions);
      const result = res?.data;
      if (result) {
        setCurrentContext(prev => ({ ...prev, stallName: result.name || '' }));
        // try multiple possible slug fields
        const slugFromApi = result.slug ?? result.Slug ?? result.shareSlug ?? result.shortCode ?? result.stallSlug ?? '';
        setStallSlug(slugFromApi || '');
      }
    } catch (err) {
      console.error('Error fetching stall:', err);
    } finally {
      getStallFollowers();
      getGroups();
    }
  };

  // ================== API: GET Stall Followers ==================
  const getStallFollowers = async () => {
    if (!stallId) return;
    setLoadingFollowers(true);
    try {
      const apiOptions: any = { url: `follow/stall/${stallId}`, data: null };
      const res = await http.get(apiOptions);
      const result = res?.data || [];
      const normalized: Follower[] = result.map((item: any) => ({
        id: item.id ?? item.Id ?? 0,
        firstName: item.firstName ?? item.FirstName ?? '',
        lastName: item.lastName ?? item.LastName ?? '',
        profileImagePath: item.profileImagePath ?? item.ProfileImagePath ?? '',
        profileImageUrl: general.getImageUrl(item.profileImagePath ?? item.ProfileImagePath ?? '')
      }));
      setUserList(normalized);
    } catch (err) {
      console.error('Error fetching followers:', err);
      setUserList([]);
    } finally {
      setLoadingFollowers(false);
    }
  };

  // ================== API: GET Groups by Stall ==================
  const getGroups = async () => {
    if (!stallId) return;
    setLoadingGroups(true);
    try {
      const apiOptions: any = { url: `truefansgroup/stall/${stallId}`, data: null };
      const res = await http.get(apiOptions);
      const data = res?.data;
      if (data?.success) {
        const mapped = (data.data || []).map((g: any) => ({
          id: g.id ?? g.Id,
          groupName: g.groupName ?? g.GroupName,
          description: g.description ?? g.Description ?? '',
          memberCount: (g.memberCount ?? g.MemberCount ?? 0) || 0,
          createdDate: g.createdDate ?? g.CreatedDate
        }));
        setGroups(mapped);
      } else {
        setGroups(data?.data ?? []);
      }
    } catch (err) {
      console.error('getGroups: error', err);
      setGroups([]);
    } finally {
      setLoadingGroups(false);
    }
  };

  // ================== API: GET Group Members (View Mode) ==================
  const handleViewMembers = async (groupId: number) => {
    setOpenMembersDialog(true);
    setLoadingMembers(true);
    setMembersDialogData(null);
    setIsEditMode(false);
    setSelectedUsersToAdd([]);
    setSelectedUsersToRemove([]);

    try {
      const res = await http.get({ url: `truefansgroup/${groupId}`, data: null });
      const payload = res?.data;

      if (payload?.success && payload.data) {
        const gd = payload.data;
        const membersArray = gd.Members || gd.members || gd.trueFansGroupMembers || gd.TrueFansGroupMembers || [];

        const normalizedMembers = membersArray.map((m: any) => ({
          userId: m.userId ?? m.UserId ?? m.id ?? m.Id,
          firstName: m.firstName ?? m.FirstName ?? '',
          lastName: m.lastName ?? m.LastName ?? '',
          profileImagePath: m.profileImagePath ?? m.ProfileImagePath ?? ''
        }));

        setMembersDialogData({
          id: gd.id ?? gd.Id,
          groupName: gd.groupName ?? gd.GroupName,
          Members: normalizedMembers
        });
      } else {
        AlertService?.showErrorMsg?.("Failed to load group data");
        setMembersDialogData({
          id: groupId,
          groupName: 'Group',
          Members: []
        });
      }
    } catch (err) {
      console.error('Error fetching group members:', err);
      AlertService?.showErrorMsg?.('Failed to fetch group members');
      setMembersDialogData({
        id: groupId,
        groupName: 'Group',
        Members: []
      });
    } finally {
      setLoadingMembers(false);
    }
  };

  // ================== API: GET Group Members (Edit Mode) ==================
  const handleEditGroup = async (groupId: number) => {
    setOpenMembersDialog(true);
    setLoadingMembers(true);
    setMembersDialogData(null);
    setIsEditMode(true);
    setSelectedUsersToAdd([]);
    setSelectedUsersToRemove([]);

    try {
      const res = await http.get({ url: `truefansgroup/${groupId}`, data: null });
      const payload = res?.data;

      if (payload?.success && payload.data) {
        const gd = payload.data;
        const membersArray = gd.Members || gd.members || gd.trueFansGroupMembers || gd.TrueFansGroupMembers || [];

        const normalizedMembers = membersArray.map((m: any) => ({
          userId: m.userId ?? m.UserId ?? m.id ?? m.Id,
          firstName: m.firstName ?? m.FirstName ?? '',
          lastName: m.lastName ?? m.LastName ?? '',
          profileImagePath: m.profileImagePath ?? m.ProfileImagePath ?? ''
        }));

        setMembersDialogData({
          id: gd.id ?? gd.Id,
          groupName: gd.groupName ?? gd.GroupName,
          Members: normalizedMembers
        });
      } else {
        AlertService?.showErrorMsg?.('Failed to load group data');
        setMembersDialogData({
          id: groupId,
          groupName: 'Group',
          Members: []
        });
      }
    } catch (err) {
      console.error('Error fetching group members:', err);
      AlertService?.showErrorMsg?.('Failed to fetch group members');
      setMembersDialogData({
        id: groupId,
        groupName: 'Group',
        Members: []
      });
    } finally {
      setLoadingMembers(false);
    }
  };

  // ================== API: DELETE Group ==================
  const handleDeleteGroup = async (groupId: number, groupName: string, e: React.MouseEvent) => {
    e.stopPropagation();

    showConfirmation(
      'Delete Group',
      `Are you sure you want to delete the group "${groupName}"? This action cannot be undone.`,
      async () => {
        try {
          await http.delete({ url: `truefansgroup/${groupId}`, data: null });
          AlertService?.showSuccessMsg?.('Group deleted successfully!');
          await getGroups();
        } catch (err) {
          console.error('Delete group error:', err);
          AlertService?.showErrorMsg?.('Failed to delete group. Please try again.');
        }
      }
    );
  };

  // ================== API: ADD Users to Group ==================
  const handleAddUsersToGroup = async () => {
    if (!membersDialogData?.id || selectedUsersToAdd.length === 0) {
      AlertService?.showErrorMsg?.('Please select users to add');
      return;
    }

    try {
      const userIds = selectedUsersToAdd.map(u => u.id);
      await http.post({
        url: `truefansgroup/${membersDialogData.id}/add-users`,
        data: { userIds }
      });

      AlertService?.showSuccessMsg?.('Users added successfully');
      setSelectedUsersToAdd([]);

      // Refresh group members
      await handleEditGroup(membersDialogData.id);
      await getGroups();
    } catch (err) {
      console.error('Error adding users:', err);
      AlertService?.showErrorMsg?.('Failed to add users to group');
    }
  };

  // ================== API: REMOVE Single User from Group ==================
  const handleRemoveUserFromGroup = async (userId: number, userName: string) => {
    if (!membersDialogData?.id) return;

    showConfirmation(
      'Remove Member',
      `Are you sure you want to remove ${userName} from the group?`,
      async () => {
        try {
          await http.delete({
            url: `truefansgroup/${membersDialogData.id}/remove-user/${userId}`
          });

          AlertService?.showSuccessMsg?.('Member removed successfully');

          // Refresh group members
          await handleEditGroup(membersDialogData.id);
          await getGroups();
        } catch (err) {
          console.error('Error removing user:', err);
          AlertService?.showErrorMsg?.('Failed to remove member from group');
        }
      }
    );
  };

  // ================== API: REMOVE Multiple Users from Group ==================
  const handleRemoveMultipleUsers = async () => {
    if (!membersDialogData?.id || selectedUsersToRemove.length === 0) {
      AlertService?.showErrorMsg?.('Please select members to remove');
      return;
    }

    showConfirmation(
      'Remove Members',
      `Are you sure you want to remove ${selectedUsersToRemove.length} member${selectedUsersToRemove.length > 1 ? 's' : ''} from the group?`,
      async () => {
        setRemovingMultiple(true);
        try {
          let successCount = 0;
          let failedCount = 0;

          for (const userId of selectedUsersToRemove) {
            try {
              await http.delete({
                url: `truefansgroup/${membersDialogData.id}/remove-user/${userId}`
              });
              successCount++;
            } catch (err) {
              failedCount++;
              console.error(`Error removing user ${userId}:`, err);
            }
          }

          if (successCount > 0) {
            let msg = `${successCount} member${successCount > 1 ? 's' : ''} removed successfully!`;
            if (failedCount > 0) {
              msg += ` (${failedCount} failed)`;
            }
            AlertService?.showSuccessMsg?.(msg);
            setSelectedUsersToRemove([]);

            // Refresh group members
            await handleEditGroup(membersDialogData.id);
            await getGroups();
          } else {
            AlertService?.showErrorMsg?.('Failed to remove members from group');
          }
        } catch (err) {
          console.error('Error removing multiple users:', err);
          AlertService?.showErrorMsg?.('Failed to remove members from group');
        } finally {
          setRemovingMultiple(false);
        }
      }
    );
  };

  // ================== HELPER: Toggle Member Selection ==================
  const toggleMemberSelection = (userId: number) => {
    setSelectedUsersToRemove(prev =>
      prev.includes(userId)
        ? prev.filter(id => id !== userId)
        : [...prev, userId]
    );
  };

  // ================== HELPER: Select/Deselect All Members ==================
  const toggleSelectAllMembers = () => {
    if (selectedUsersToRemove.length === membersDialogData?.Members?.length) {
      setSelectedUsersToRemove([]);
    } else {
      setSelectedUsersToRemove(membersDialogData?.Members?.map((m: MemberData) => m.userId) || []);
    }
  };

  // ================== NAVIGATION: Open DM with Follower ==================
  const navToMessage = (selectedUserId: number) => {
    setFollowedUserId(selectedUserId);
    setOpenMessage(true);
  };

  // ================== MODAL: Create TrueFans Group ==================
  const handleCreateTrueFansGroupOpen = () => setOpenCreateTrueFansGroup(true);
  const handleCreateTrueFansGroupClose = () => {
    setOpenCreateTrueFansGroup(false);
    getGroups();
  };

  // ================== DIALOG: Open Notification/Messaging Dialog (for groups) ==================
  const openNotificationWindow = (group: GroupData) => {
    setSelectedGroupForNotification(group);
    setSelectedTab(0);
    setDmMessage('');
    setPushTitle('');
    setPushBody('');
    setPushImageUrl('');
    // prefill the link fields with generatedStallLink (non-editable)
    const link = generatedStallLink || '';
    setPushLink(link);
    setWaProductLink(link);
    setWaDiscountLink(link);
    // set a sensible default preview image instead of empty
    setWaPreviewImage(
      waTemplate === 'discount'
        ? 'https://d3e4oen9k5mseu.cloudfront.net/Meta_Promotion_img/Flash_Sale_Sample.png'
        : 'https://d3e4oen9k5mseu.cloudfront.net/Meta_Promotion_img/New_Product_Alert_sample.png'
    );
    setWaDateError(false);
    setOpenNotificationDialog(true);
  };

  // ================== DIALOG: Close Notification/Messaging Dialog ==================
  const closeNotificationDialog = () => {
    setOpenNotificationDialog(false);
    setSelectedGroupForNotification(null);
    setDmMessage('');
    setPushTitle('');
    setPushBody('');
    setPushImageUrl('');
    setPushLink('');
    // reset whatsapp states as well
    setWaProductName('');
    setWaDate('');
    setWaProductLink('');
    setWaDiscountLink('');
    setWaTemplate('new_product');
    setWaPreviewImage('');
    setWaDateError(false);
  };

  // ================== RENDER: Groups Section ==================
  const renderGroupsBar = () => (
    <div style={{ margin: '1rem 1rem 0 1rem' }}>
      <Typography variant="h6" style={{marginBottom: 8, color: '#f69516', fontWeight: 700, textAlign: 'center' }}>
        Created Groups
      </Typography>

      {loadingGroups ? (
        <Box display="flex" alignItems="center" gap={1}>
          <CircularProgress size={20} />
          <Typography>Loading groups...</Typography>
        </Box>
      ) : groups.length === 0 ? (
        <Typography color="textSecondary" style={{ textAlign: 'center' }}>No groups created yet</Typography>

      ) : (
        <div className={classes.groupsContainer}>
          {groups.map((g: GroupData) => {
            const id = g.id;
            const name = g.groupName;
            const desc = g.description;
            const members = g.memberCount;

            return (
              <Card
                key={id}
                className={classes.groupCard}
                elevation={2}
                style={{ cursor: 'pointer' }}
                onClick={() => openNotificationWindow(g)}
              >
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                    <div style={{ flex: 1, paddingRight: 8 }}>
                      <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#f69516' }}>
                        {name}
                      </Typography>
                      {desc && (
                        <Typography variant="caption" color="textSecondary">
                          {desc.length > 60 ? desc.slice(0, 60) + '…' : desc}
                        </Typography>
                      )}
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <Box display="flex" alignItems="center" justifyContent="flex-end">
                        <GroupIcon style={{ marginRight: 6 }} />
                        <Typography variant="body2">{members}</Typography>
                      </Box>
                    </div>
                  </Box>
                </CardContent>
                <CardActions style={{ justifyContent: 'space-between' }}>
                  <Button
                    size="small"
                    startIcon={<SettingsIcon />}
                    onClick={(e) => { e.stopPropagation(); handleEditGroup(id); }}
                  >
                    Edit
                  </Button>
                  <IconButton
                    size="small"
                    onClick={(e) => handleDeleteGroup(id, name, e)}
                    title="Delete group"
                  >
                    <DeleteIcon />
                  </IconButton>
                </CardActions>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );

  // ================== RETURN: Main JSX ==================
  return (
    <div className="followedusers-ui pt-5">
      {/* HEADER: Breadcrumb */}
      <div className="title-font custom-head pt-4 mt-3 pl-4">
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="primary" className="custom-link pointer breadcrumbs-style pl-2" onClick={navToDashboard}>
            <b>Provider Dashboard</b>
          </Link>
          <Typography color="primary" className="breadcrumbs-style">
            True Fans
          </Typography>
        </Breadcrumbs>
      </div>

      {/* TOP: Create Group Button & Sections */}
      <div className="m-2 position-relative">
        <div className={classes.topRightButton}>
          <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleCreateTrueFansGroupOpen}>
            Create Group
          </Button>
        </div>

        {/* Stall Name */}
        <div className="row pt-3 pb-2 pl-3">
          <span className="pl-3">{currentContext.stallName} Fans</span>
        </div>

        {/* Groups Display */}
        {renderGroupsBar()}

        {/* Followers Table */}
        <div className="px-3 py-3">
          <TableContainer component={Paper}>
            <Table size="small" className="table-striped">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell width="80%">Name</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loadingFollowers ? (
                  <TableRow>
                    <TableCell colSpan={3} style={{ textAlign: 'center', padding: 20 }}>
                      <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                        <CircularProgress size={20} />
                        <Typography variant="body2">Loading followers...</Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : userList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} style={{ textAlign: 'center', padding: 20 }}>
                      <Typography variant="body2" color="textSecondary">
                        No followers found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  userList.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>
                        <img src={item.profileImageUrl || dummyImage} alt="Profile" width="50" height="50" />
                      </TableCell>
                      <TableCell>
                        <span>{item.firstName}</span>
                        {item.lastName && <span> {item.lastName}</span>}
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center">
                          {/* DM */}
                          <Tooltip title="Direct message">
                            <span
                              className="pointer"
                              style={{ marginRight: 25 }} 
                              onClick={() => navToMessage(item.id)}
                            >
                              <i className="fas fa-paper-plane header-icon-style" style={{ fontSize: 18 }}></i>
                            </span>
                          </Tooltip>

                          {/* Push Notification (individual) */}
                          <Tooltip title="Send Push Notification">
                            <IconButton
                              size="small"
                              onClick={() => openPushForUser(item)}
                              style={{ color: '#f69516' }}
                            >
                              <NotificationsActiveIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>

                          {/* WhatsApp (individual) */}
                          <Tooltip title="Send WhatsApp Message">
                            <IconButton
                              size="small"
                              onClick={() => openWhatsAppForUser(item)}
                              style={{ color: '#25D366',  marginLeft: 25 }}
                           
                            >
                              <WhatsAppIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>

      {/* DRAWER: Direct Message Container */}
      <Drawer anchor={"right"} classes={{ paper: classes.drawerWidth }} open={openMessage} onClose={toggleDrawerMessage}>
        <MessageContainer followedUserId={followedUserId} handleMessageClose={() => setOpenMessage(false)} />
      </Drawer>

      {/* MODAL: Create TrueFans Group */}
      {openCreateTrueFansGroup && (
        <CreateTrueFansGroupModal
          open={openCreateTrueFansGroup}
          stallId={stallId}
          stallName={currentContext.stallName}
          followers={userList}
          onClose={handleCreateTrueFansGroupClose}
        />
      )}

      {/* DIALOG: Custom Confirmation Dialog */}
      <Dialog
        open={confirmDialog.open}
        onClose={handleConfirmNo}
        className={classes.confirmDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ paddingBottom: 16 }}>
          <Box display="flex" alignItems="center" gap={1}>
            <WarningIcon style={{ color: '#ff9800' }} />
            <Typography variant="h6" style={{ fontWeight: 700 }}>
              {confirmDialog.title}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary">
            {confirmDialog.message}
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px', gap: '8px' }}>
          <Button
            onClick={handleConfirmNo}
            variant="outlined"
            disabled={confirmDialog.isLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmYes}
            variant="contained"
            color="secondary"
            disabled={confirmDialog.isLoading}
            startIcon={confirmDialog.isLoading ? <CircularProgress size={20} /> : <DeleteIcon />}
          >
            {confirmDialog.isLoading ? 'Processing...' : 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* DIALOGS: Members Edit & View */}
      <Dialog
        open={openMembersDialog && isEditMode}
        onClose={() => {
          setOpenMembersDialog(false);
          setMembersDialogData(null);
          setSelectedUsersToAdd([]);
          setSelectedUsersToRemove([]);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{membersDialogData?.groupName ?? 'Edit Group Members'}</Typography>
            <IconButton
              size="small"
              onClick={() => {
                setOpenMembersDialog(false);
                setMembersDialogData(null);
                setSelectedUsersToAdd([]);
                setSelectedUsersToRemove([]);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {loadingMembers ? (
            <Box display="flex" alignItems="center" justifyContent="center" gap={1} py={3}>
              <CircularProgress size={24} />
              <Typography>Loading group members...</Typography>
            </Box>
          ) : (
            <Box>
              {/* Add Members Section */}
              <Box mb={3}>
                <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 600 }}>
                  Add New Members
                </Typography>
                <Autocomplete
                  multiple
                  value={selectedUsersToAdd}
                  options={userList.filter(u => !membersDialogData?.Members?.some((m: MemberData) => m.userId === u.id))}
                  getOptionLabel={(option) => `${option.firstName} ${option.lastName || ''}`.trim()}
                  onChange={(e, value) => setSelectedUsersToAdd(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Select members to add"
                      placeholder="Search followers..."
                      size="small"
                    />
                  )}
                  renderOption={(option) => (
                    <Box display="flex" alignItems="center">
                      <img
                        src={general.getImageUrl(option.profileImagePath || '') || dummyImage}
                        alt="profile"
                        width={32}
                        height={32}
                        style={{ borderRadius: 16, marginRight: 10 }}
                      />
                      <Typography>{option.firstName} {option.lastName}</Typography>
                    </Box>
                  )}
                />
                {selectedUsersToAdd.length > 0 && (
                  <Box mt={1}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={handleAddUsersToGroup}
                      startIcon={<AddIcon />}
                    >
                      Add {selectedUsersToAdd.length} Member{selectedUsersToAdd.length > 1 ? 's' : ''}
                    </Button>
                  </Box>
                )}
              </Box>

              {/* Current Members Section */}
              <Box>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                    Current Members ({membersDialogData?.Members?.length || 0})
                  </Typography>
                  {membersDialogData?.Members?.length > 0 && isEditMode && (
                    <Box display="flex" gap={1} alignItems="center">
                      <Checkbox
                        size="small"
                        checked={selectedUsersToRemove.length === membersDialogData?.Members?.length && membersDialogData?.Members?.length > 0}
                        indeterminate={selectedUsersToRemove.length > 0 && selectedUsersToRemove.length < membersDialogData?.Members?.length}
                        onChange={toggleSelectAllMembers}
                        title="Select all"
                      />
                      <Typography variant="caption" style={{ fontWeight: 500 }}>
                        {selectedUsersToRemove.length > 0 ? `${selectedUsersToRemove.length} selected` : 'Select all'}
                      </Typography>
                    </Box>
                  )}
                </Box>

                {!membersDialogData?.Members || membersDialogData.Members.length === 0 ? (
                  <Box py={2} textAlign="center">
                    <Typography color="textSecondary" variant="body2">
                      No members in this group yet.
                    </Typography>
                  </Box>
                ) : (
                  <Box style={{ maxHeight: 300, overflowY: 'auto' }}>
                    {membersDialogData.Members.map((m: MemberData, idx: number) => (
                      <Box
                        key={m.userId ?? idx}
                        className={`${classes.memberRow} ${selectedUsersToRemove.includes(m.userId) ? 'selected' : ''}`}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '12px 8px',
                          borderBottom: '1px solid #e0e0e0',
                          backgroundColor: selectedUsersToRemove.includes(m.userId) ? '#e3f2fd' : '#fafafa',
                          marginBottom: '4px',
                          borderRadius: '4px',
                          borderLeft: selectedUsersToRemove.includes(m.userId) ? '3px solid #2196f3' : 'none',
                          transition: 'all 0.2s ease',
                          cursor: isEditMode ? 'pointer' : 'default'
                        }}
                        onClick={() => isEditMode && toggleMemberSelection(m.userId)}
                      >
                        {isEditMode && (
                          <Checkbox
                            size="small"
                            checked={selectedUsersToRemove.includes(m.userId)}
                            onChange={(e) => {
                              e.stopPropagation();
                              toggleMemberSelection(m.userId);
                            }}
                            onClick={(e) => e.stopPropagation()}
                            style={{ marginRight: '8px' }}
                          />
                        )}
                        <img
                          src={general.getImageUrl(m.profileImagePath || '') || dummyImage}
                          alt="profile"
                          width={40}
                          height={40}
                          style={{ borderRadius: 20, marginRight: 12 }}
                        />
                        <Typography style={{ flex: 1, fontWeight: 500 }}>
                          {m.firstName} {m.lastName}
                        </Typography>
                        {isEditMode && (
                          <IconButton
                            size="small"
                            className={classes.deleteButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveUserFromGroup(m.userId, `${m.firstName} ${m.lastName}`);
                            }}
                            title="Remove member"
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        )}
                      </Box>
                    ))}
                  </Box>
                )}

                {/* Bulk Remove Button */}
                {isEditMode && selectedUsersToRemove.length > 0 && (
                  <Box mt={2}>
                    <Button
                      variant="contained"
                      className={classes.bulkDeleteButton}
                      fullWidth
                      onClick={handleRemoveMultipleUsers}
                      disabled={removingMultiple}
                      startIcon={removingMultiple ? <CircularProgress size={20} /> : <DeleteIcon />}
                    >
                      {removingMultiple ? 'Removing...' : `Remove ${selectedUsersToRemove.length} Member${selectedUsersToRemove.length > 1 ? 's' : ''}`}
                    </Button>
                  </Box>
                )}
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenMembersDialog(false);
              setMembersDialogData(null);
              setSelectedUsersToAdd([]);
              setSelectedUsersToRemove([]);
            }}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openMembersDialog && !isEditMode}
        onClose={() => {
          setOpenMembersDialog(false);
          setMembersDialogData(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{membersDialogData?.groupName ?? 'Group Members'}</Typography>
            <IconButton
              size="small"
              onClick={() => {
                setOpenMembersDialog(false);
                setMembersDialogData(null);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {loadingMembers ? (
            <Box display="flex" alignItems="center" gap={1}>
              <CircularProgress size={20} />
              <Typography>Loading members...</Typography>
            </Box>
          ) : !membersDialogData || !Array.isArray(membersDialogData.Members) ? (
            <Typography color="textSecondary">No members found</Typography>
          ) : (
            <Box>
              {membersDialogData.Members.map((m: MemberData, idx: number) => (
                <Box
                  key={m.userId ?? idx}
                  display="flex"
                  alignItems="center"
                  style={{ padding: 8, borderBottom: '1px solid #f0f0f0' }}
                >
                  <img
                    src={general.getImageUrl(m.profileImagePath || '') || dummyImage}
                    alt="profile"
                    width={40}
                    height={40}
                    style={{ borderRadius: 20, marginRight: 10 }}
                  />
                  <div>
                    <Typography variant="body2">
                      {m.firstName} {m.lastName || ''}
                    </Typography>
                  </div>
                </Box>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenMembersDialog(false);
              setMembersDialogData(null);
            }}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* DIALOG: Group Messaging with Tabs - LARGER WINDOW */}
      <Dialog
        open={openNotificationDialog}
        onClose={closeNotificationDialog}
        className={classes.notificationDialog}
        maxWidth={false}
      >
        {/* Dialog Header */}
        <DialogTitle style={{ background: '#f69516', color: '#fff', fontWeight: 700, padding: '16px 24px', flexShrink: 0 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" style={{ margin: 0, color: '#fff', fontWeight: 700 }}>
              Send Notification
            </Typography>
            <IconButton size="small" onClick={closeNotificationDialog} style={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        {/* Tabs */}
        <Box className={classes.tabsContainer} style={{ flexShrink: 0 }}>
          <Tabs
            value={selectedTab}
            onChange={(e, newValue) => {
              setSelectedTab(newValue);
              // When user navigates to WhatsApp tab, ensure preview exists
              if (newValue === 2) {
                if (!waPreviewImage) {
                  setWaPreviewImage(
                    waTemplate === 'discount'
                      ? 'https://d3e4oen9k5mseu.cloudfront.net/Meta_Promotion_img/Flash_Sale_Sample.png'
                      : 'https://d3e4oen9k5mseu.cloudfront.net/Meta_Promotion_img/New_Product_Alert_sample.png'
                  );
                }
                // re-check date error if any
                if (waDate.length === 10) {
                  setWaDateError(!isValidDateFormat(waDate));
                }
              }
            }}
            classes={{ indicator: classes.tabIndicator }}
            variant="fullWidth"
          >
            <Tab label="SEND DM" className={classes.tabButton} />
            <Tab label="PUSH NOTIFICATION" className={classes.tabButton} />
            <Tab label="WHATSAPP" className={classes.tabButton} />
          </Tabs>
        </Box>

        {/* Dialog Content - FLEXIBLE SIZE WITHOUT SCROLL */}
        <DialogContent className={classes.dialogContent}>
          {/* Group Info Box */}
          <Box style={{ background: '#e8f5e9', padding: '16px', borderRadius: '8px', border: '1px solid #8ec73d', marginBottom: 24 }}>
            <Typography variant="body1" style={{ fontWeight: 700, color: '#2e7d32', marginBottom: 4 }}>
              {selectedGroupForNotification?.groupName}
            </Typography>
            <Typography variant="body2" style={{ color: '#388e3c' }}>
              Recipients: {selectedGroupForNotification?.memberCount ?? 0} users
            </Typography>
            {selectedGroupForNotification?.isIndividual && (
              <Typography variant="caption" color="textSecondary">Sending to single user</Typography>
            )}
          </Box>

          {/* TAB 0: Send DM */}
          {selectedTab === 0 && (
            <Box display="flex" flexDirection="column" gap={2}>
              <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                Send individual direct messages to each group member. Messages will be sent to their personal chats.
              </Typography>
              <TextField
                label="Message *"
                value={dmMessage}
                onChange={(e) => setDmMessage(e.target.value)}
                fullWidth
                multiline
                rows={10}
                variant="outlined"
                placeholder="Type your message to send individual DMs to each member..."
                helperText="Each member will receive this as a personal direct message"
              />
            </Box>
          )}

          {/* TAB 1: Push Notification */}
          {selectedTab === 1 && (
            <Box display="flex" flexDirection="column" gap={3}>
              <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                Send push notifications to all group members or individual users. Notifications will appear on their devices.

              </Typography>
              <Box>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
                  <span style={{ color: '#d32f2f' }}></span>
                </Typography>
                <TextField
                  label="Title *"
                  value={pushTitle}
                  onChange={(e) => setPushTitle(e.target.value)}
                  fullWidth
                  variant="outlined"
                  size="medium"
                  placeholder="e.g., Special Offer, New Update"
                />
              </Box>

              <Box>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
                  <span style={{ color: '#d32f2f' }}></span>
                </Typography>
                <TextField
                  label="Description *"
                  value={pushBody}
                  onChange={(e) => setPushBody(e.target.value)}
                  fullWidth
                  multiline
                  rows={6}
                  variant="outlined"
                  placeholder="Provide detailed description of your notification..."
                />
              </Box>

              <Box>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
                   <span style={{ color: '#999' }}></span>
                </Typography>
                <TextField
                  label="Image URL"
                  value={pushImageUrl}
                  onChange={(e) => setPushImageUrl(e.target.value)}
                  fullWidth
                  variant="outlined"
                  size="medium"
                  placeholder="e.g., https://example.com/image.jpg"
                />
              </Box>

              <Box>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
                  <span style={{ color: '#999' }}></span>
                </Typography>
                {/* Link field */}
                  <TextField
                    label=""
                    value={pushLink}
                    onChange={(e) => setPushLink(e.target.value)}
                    fullWidth
                    variant="outlined"
                    size="small"
                    margin="dense"
                    placeholder="Optional: e.g., https://example.com"
                    InputProps={{
                      readOnly: true,
                      style: { 
                        backgroundColor: '#dcdcdc',
                        color: '#666666'
                      }
                    }}
                  />


              </Box>
            </Box>
          )}

          {/* TAB 2: WhatsApp */}
          {selectedTab === 2 && (
            <Box>
              <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{ marginBottom: 6 }}
                >
                  Send a WhatsApp message to all group members or an individual user. Messages will be delivered to their WhatsApp accounts.
.
                </Typography>

                <Typography
                  variant="body2"
                  style={{ color: '#f69516', fontWeight: 600, marginBottom: 12 }}
                >
                  NOTE: User Name {'{1}'} will be auto-fetched for each group member.
                </Typography>

              <Box display="flex" alignItems="center" gap={2} mb={3} flexWrap="wrap">
                <Button
                  variant={waTemplate === 'new_product' ? 'contained' : 'outlined'}
                  className={`${classes.waTemplateButton} ${waTemplate === 'new_product' ? classes.waTemplateActive : ''}`}
                  onClick={() => {
                    setWaTemplate('new_product');
                    setWaPreviewImage('https://d3e4oen9k5mseu.cloudfront.net/Meta_Promotion_img/New_Product_Alert_sample.png');
                  }}
                  style={{ marginRight: 12 }}
                >
                  T1 — New Product Alert
                </Button>

                <Button
                  variant={waTemplate === 'discount' ? 'contained' : 'outlined'}
                  className={`${classes.waTemplateButton} ${waTemplate === 'discount' ? classes.waTemplateActive : ''}`}
                  onClick={() => {
                    setWaTemplate('discount');
                    setWaPreviewImage('https://d3e4oen9k5mseu.cloudfront.net/Meta_Promotion_img/Flash_Sale_Sample.png');
                  }}
                >
                  T2 — Flash Sale
                </Button>
              </Box>

              <Box>
                {waTemplate === 'new_product' && (
                  <Box display="flex" flexDirection="column">
                 <Box mb={2}>
                     <TextField
                        label="{2} Product name *"
                        value={waProductName}
                        onChange={(e) => setWaProductName(e.target.value)}
                        fullWidth
                        variant="outlined"
                        size="small"
                        margin="normal"
                        placeholder="Product name"
                        InputProps={{
                            style: { height: 38 }
                          }}
                      />
                    </Box>

                    <Box mb={2}>
                      <TextField
                        label="{3} Date (DD/MM/YYYY) *"
                        value={waDate}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (!/^[0-9/]*$/.test(value)) return;
                          if (value.length > 10) return;
                          setWaDate(value);

                          if (value.length === 10) {
                            setWaDateError(!isValidDateFormat(value));
                          } else {
                            setWaDateError(false);
                          }
                        }}
                        fullWidth
                        variant="outlined"
                        size="small"
                        margin="normal"
                        placeholder="DD/MM/YYYY"
                        InputProps={{
                            style: { height: 38 }
                          }}
                        inputProps={{
                          maxLength: 10
                        }}
                        error={waDateError}
                        helperText={waDateError ? 'Enter a valid date in DD/MM/YYYY format' : ''}
                      />
                    </Box>

                    <Box mb={2}>
                      <TextField
                        label=""
                        value={waProductLink}
                        fullWidth
                        variant="outlined"
                        size="small"
                        margin="dense"
                        placeholder={generatedStallLink ? generatedStallLink : "No link available"}
                        InputProps={{
                          readOnly: true,
                          style: {
                            height: 38,
                            backgroundColor: '#dcdcdc'
                          },
                          inputProps: {
                            style: {
                              color: '#757575'
                            }
                          }
                        }}
                      />
                    </Box>
                  </Box>
                )}

                {waTemplate === 'discount' && (
                  <Box display="flex" flexDirection="column">
                    <Box mb={2}>
                      <TextField
                        label=""
                        value={waProductLink}
                        fullWidth
                        variant="outlined"
                        size="small"
                        margin="dense"
                        placeholder={generatedStallLink ? generatedStallLink : "No link available"}
                        InputProps={{
                          readOnly: true,
                          style: {
                            height: 38,
                            backgroundColor: '#dcdcdc'
                          },
                          inputProps: {
                            style: {
                              color: '#757575'
                            }
                          }
                        }}
                      />
                    </Box>
                  </Box>
                )}
              </Box>

              {waPreviewImage && (
                <Box mt={3} display="flex" justifyContent="center">
                  <img
                    src={waPreviewImage}
                    alt="WhatsApp template preview"
                    className={classes.waPreviewImg}
                  />
                </Box>
              )}
            </Box>
          )}

        </DialogContent>

        {/* Dialog Actions */}
        <DialogActions style={{ padding: '16px 24px', background: '#e9e9e9', borderTop: '1px solid #e0e0e0', gap: '12px', flexShrink: 0 }}>
          <Button
            onClick={closeNotificationDialog}
            color="default"
            variant="outlined"
            style={{ minWidth: 100 }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (selectedTab === 0) {
                (sendDMToGroup as any)();
              } else if (selectedTab === 1) {
                (sendPushNotification as any)();
              } else {
                sendWhatsAppMessage();
              }
            }}

            disabled={
              dmSending ||
              pushSending ||
              waSending ||
              !isOverallSendEnabled()
            }

            variant="contained"
            startIcon={<SendIcon />}
            className={isOverallSendEnabled() ? classes.sendButtonEnabled : classes.sendButtonDisabled}
            style={{ minWidth: 120, fontWeight: 700 }}
          >
            {getSendButtonLabel()}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FollowedUsers;
